import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultarLDAP_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ConsultarLDAP",
    rutaEndPoint: "/EnterpriseServices/Sel/Cuenta/consultarLDAP",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: false,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//Entrada

export interface ConsultarLDAP_Entrada {
    descripcion:        string;
    aclBTG:             string;
    apellidoPaterno:    string;
    TelTrab:            string;
    statusOTT:          string;
    TelMovil:           string;
    nombre:             string;
    ctaSky:             string;
    apellidoMaterno:    string;
    password:           string;
    contactoRowID:      string;
    statusSEL:          string;
    TelMovilLada:       string;
    statusSky:          string;
    TelTrabLada:        string;
    paqueteSky:         string;
    statusBTG:          string;
    aclSEL:             string;
    email:              string;
    TelCasaLada:        string;
    TarjetaInteligente: string;
    buscaCuentaValue:   string;
    nombreCorp:         string;
    Atributos:          Atributo[];
    aclOTT:             string;
    TelCasa:            string;
    UID:                string;
    buscaCuentaParam:   string;
    TelTrabExt:         string;
    tipoCuenta:         string;
    OperacionLDAP:      string;
    titular:            string;
    username:           string;
}

export function builtConsultarLDAP_entrada(
    p_descripcion:        string,
    p_aclBTG:             string,
    p_apellidoPaterno:    string,
    p_TelTrab:            string,
    p_statusOTT:          string,
    p_TelMovil:           string,
    p_nombre:             string,
    p_ctaSky:             string,
    p_apellidoMaterno:    string,
    p_password:           string,
    p_contactoRowID:      string,
    p_statusSEL:          string,
    p_TelMovilLada:       string,
    p_statusSky:          string,
    p_TelTrabLada:        string,
    p_paqueteSky:         string,
    p_statusBTG:          string,
    p_aclSEL:             string,
    p_email:              string,
    p_TelCasaLada:        string,
    p_TarjetaInteligente: string,
    p_buscaCuentaValue:   string,
    p_nombreCorp:         string,
    p_Atributos:          Atributo[],
    p_aclOTT:             string,
    p_TelCasa:            string,
    p_UID:                string,
    p_buscaCuentaParam:   string,
    p_TelTrabExt:         string,
    p_tipoCuenta:         string,
    p_OperacionLDAP:      string,
    p_titular:            string,
    p_username:           string    
  ) {
    var retorno: ConsultarLDAP_Entrada = {
        descripcion:        p_descripcion,
        aclBTG:             p_aclBTG,
        apellidoPaterno:    p_apellidoPaterno,
        TelTrab:            p_TelTrab,
        statusOTT:          p_statusOTT,
        TelMovil:           p_TelMovil,
        nombre:             p_nombre,
        ctaSky:             p_ctaSky,
        apellidoMaterno:    p_apellidoMaterno,
        password:           p_password,
        contactoRowID:      p_contactoRowID,
        statusSEL:          p_statusSEL,
        TelMovilLada:       p_TelMovilLada,
        statusSky:          p_statusSky,
        TelTrabLada:        p_TelTrabLada,
        paqueteSky:         p_paqueteSky,
        statusBTG:          p_statusBTG,
        aclSEL:             p_aclSEL,
        email:              p_email,
        TelCasaLada:        p_TelCasaLada,
        TarjetaInteligente: p_TarjetaInteligente,
        buscaCuentaValue:   p_buscaCuentaValue,
        nombreCorp:         p_nombreCorp,
        Atributos:          p_Atributos,
        aclOTT:             p_aclOTT,
        TelCasa:            p_TelCasa,
        UID:                p_UID,
        buscaCuentaParam:   p_buscaCuentaParam,
        TelTrabExt:         p_TelTrabExt,
        tipoCuenta:         p_tipoCuenta,
        OperacionLDAP:      p_OperacionLDAP,
        titular:            p_titular,
        username:           p_username
    };
  
    return retorno;
  }

export interface Atributo {
    ValorAtributo: string;
    Atributo:      string;
}

export function builtAtributoConsultarLDAP_entrada( p_ValorAtributo: string, p_Atributo: string) {
    var retorno: Atributo = {
        ValorAtributo: p_ValorAtributo,
        Atributo: p_Atributo
    };
  
    return retorno;
}



//SALIDA

export interface ConsultarLDAP_Salida {
    Atributos:     Atributo[];
    respuesta:     string;
    respuestaCode: string;
}

export interface Atributo {
    Atributo:      string;
    ValorAtributo: string;
}



export type ConsultarLDAP_Respuesta = ConsultarLDAP_Salida;